module.exports = __webpack_public_path__ + "img/ios-cloudy.f7bf5d2a.svg";